<template>
  <div class="page">
    <el-dialog
      :visible.sync="debt"
      :modal="false"
      top="6vh"
      style="margin-top: 50px;"
      :close-on-click-modal="false"
      title="退房结果"
      :before-close="refundClose"
    >
      <div>
        <p>
          {{this.hintMsg}}
        </p>
        <p v-if="this.showData">
          <b>{{this.titleMsg}}</b>
        </p>
        <el-table
          :data="this.debtList"
          style="width: 100%; margin-top: 20px"
          :max-height="tableHeight"
          v-if="this.showData"
        >
          <el-table-column prop="pricingName" label="项目名称" align="center">
          </el-table-column>
          <el-table-column prop="billStart" label="开始时间" align="center">
          </el-table-column>
          <el-table-column prop="billEnd" label="结束时间" align="center">
          </el-table-column>
          <el-table-column label="应收金额" align="center">
            <template slot-scope="scope">
              <span>{{ numFormat(scope.row.totalAmount) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="实收金额" align="center">
            <template slot-scope="scope">
              <span>{{ numFormat(scope.row.paidAmount) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="comment" label="备注" align="center">
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import Utils from "../../Utils";
import mixins from "../../minix";
import { Loading } from "element-ui";

export default {
  name: "refund",

  props: {
    type: String,
    file: String
  },

  mixins: [mixins],

  data() {
    return {
      tableHeight:'',
      hintMsg: '',
      showData: false,
      debtCount:0,
      total:0,
      paid:0,
      debtList:[],
      debt:false,
    };
  },

  created() {

  },
mounted() {
    // *****监听页面窗口改变函数  设置其宽高值 *****
    this.tableHeight = document.documentElement.clientHeight*0.5;
    window.onresize = () => {
      return (() => {
        this.tableHeight = document.documentElement.clientHeight*0.5;
      })();
    };
  },
  methods: {
    refundClose(done) {
      this.$emit('close')
      done()
    },
    // 退房：终止租约
    checkOutLease(leaseID,orgID){
      // var message = ```
      // <div style="align:'center'">
      // 退房功能用于租客退房或者换房时，解除房源的租约，并进行相关费用的结算。该功能会执行以下操作：
      // <br>1、解除当前合同，并且所有未生效账单以及续约租约都将作废（已生效的账单仍需支付）
      // <br>2、根据当前时间的电表读数计算待缴电费，并自动从用户余额中进行扣除（需要绑定智能电表）
      // </div>
      // <br>
      // <br>是否执行退房？
      // ```
      var message ="<div style="+'"text-align:'+'left">'+"退房功能用于租客退房或者换房时，解除房源的租约，并进行相关费用的结算。该功能会执行以下操作：<br"+
     "<br><li>解除当前合同，并且所有未生效账单以及续约租约都将作废（已生效的账单仍需支付）</li>"+
     "<li>根据当前时间的电表读数计算待缴电费，并自动从用户余额中进行扣除（需要绑定智能电表）</li></div>"+
     "<br>是否执行退房？"
      this.$confirm(
        message,
        "温馨提示",
        {
          center: true,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          customClass: 'refund',
          dangerouslyUseHTMLString:true,
        }
      ).then(() => { 
        this.total=0,
        this.paid=0
        const loading = Loading.service({
          lock: true,
          text: "正在请求中...",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.1)",
        });
          axios({
            method: "post",
            url: "leases/checkout",
            data: {
              leaseID: leaseID,
              orgID: orgID,
            }
          })
            .then(value => {
              if (value.data.code === 0) {
                if(value.data.data.length>0){
                  value.data.data.forEach((item) => {
                  item.billStart = Utils.long2day(item.billStart * 1000);
                  item.billEnd = Utils.long2day(item.billEnd * 1000);
                  item.totalAmount = item.totalAmount/100;
                  item.paidAmount = item.paidAmount/100;
                  this.paid+=item.paidAmount;
                  this.total+= item.totalAmount;
                  this.debtList.push(item)
                  })
                  this.debtCount = this.total-this.paid;
                  this.titleMsg="应收金额："+this.numFormat(this.total)+"，实收金额："+this.numFormat(this.paid)+"，欠款金额："+this.numFormat(this.debtCount)
                  this.hintMsg="当前房源还存在以下待缴账单，请提醒承租人缴费（账单结清后，将自动完成退房）"
                  this.showData = true
                }else{
                  this.hintMsg="退房完成，所有账单已缴清"
                  this.showData = false
                }
                
                
                this.debt = true
              } else {
                this.$message.error(value.data.message);
              }
            })
            .catch(() => {})
          .finally((_) => {
            loading.close();
          });
        })
        .catch(() => {});
    },
  }
};
</script>
<!--样式不可写在带有scoped的style标签里。在使用了>>>和/deep/方法后都不可更改样式。-->
<style >
.refund {
width: 700px;
}
</style>
<style lang="scss" scoped>
@import "../../style.css";
.main {
  margin-left: 30%;
  width: 40%;
  text-align: left;
  min-height: 130px;

  display: flex;
  flex-direction: column;
}
</style>
